import { format } from 'date-fns';
import { capitalizeFirstLetter } from 'helpers/capitalizeFirstLetter';
import { defaultDateFnsLocale } from 'helpers/locale';
import i18n from 'i18n';
import { CalendarOutlined } from 'icons';
import { Divider } from 'pages/NewOverview/components/Divider';
import { CSSProperties, ReactElement, ReactNode } from 'react';
import { colors } from 'styles/colors';
import { GraphTooltipContainer, MonthContainer } from './styles';

interface GraphTooltipProps {
  date: string;
  children: ReactNode;
  type: 'day' | 'month';
  dataTestId?: string;
  style?: CSSProperties;
}

export function GraphTooltip({
  children,
  date,
  type,
  style,
  dataTestId,
}: Readonly<GraphTooltipProps>): ReactElement {
  function formatDate(): string {
    const formattedDate = capitalizeFirstLetter(
      format(new Date(date), 'MMMM yyyy', { locale: defaultDateFnsLocale }),
    );

    if (type === 'day') {
      const day = format(new Date(date), `dd ${i18n.language === 'pt' ? "'de' " : ''}`, { locale: defaultDateFnsLocale });

      return `${day}${formattedDate}`;
    }

    return formattedDate;
  }

  return (
    <GraphTooltipContainer style={style} data-testId={dataTestId}>
      <MonthContainer>
        <CalendarOutlined color={colors.icon['primary-base']} size="16" />
        <span>{formatDate()}</span>
      </MonthContainer>
      <Divider style={{ width: '100%' }} />
      {children}
    </GraphTooltipContainer>
  );
}
